import React from 'react';

interface ChipProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  active: boolean;
  children: React.ReactNode;
  count?: number;
  size?: 'sm' | 'md';
}

// Toggleable filter pill. Active = inverted (fg background).
export const Chip: React.FC<ChipProps> = ({
  active,
  children,
  count,
  size = 'md',
  className = '',
  ...props
}) => {
  const sizes = {
    sm: 'h-8 px-3 text-xs gap-1.5',
    md: 'h-10 px-3.5 text-sm gap-2',
  };

  return (
    <button
      type="button"
      aria-pressed={active}
      className={`
        inline-flex items-center rounded-full border font-medium whitespace-nowrap transition-colors duration-150
        ${sizes[size]}
        ${active
          ? 'bg-fg border-fg text-canvas'
          : 'bg-transparent border-line-strong text-fg hover:border-fg'
        }
        ${className}
      `}
      {...props}
    >
      {children}
      {count !== undefined && (
        <span className="font-mono text-xs opacity-65">{count}</span>
      )}
    </button>
  );
};
